import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as moment1 from 'moment-timezone';
//Local query file
import {
  CommonQueryService,
  ScheduleQueryService,
} from '../../queryFiles/index';


/**Local file */
import { orders, spekwo, checkoutFields, decodeData, orderAgentRoles, statusOrder } from '../../utils/index';
import { environment } from '../../../../../../environments/environment';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';



@Injectable()
export class CommonOrdersService implements Resolve<any> {
  public orders: any;
  routeParams: any;

  ordersValues = orders;
  spekwoValues = spekwo;
  checkoutFields = checkoutFields;
  orderAgentRoles = orderAgentRoles;
  statusOrder = statusOrder;
  prevLoadedOrder: BehaviorSubject<any> = new BehaviorSubject({
    totalCount: null,
    allOrders: [],
    pageIndex: null
  });
  listOfStatus: BehaviorSubject<any> = new BehaviorSubject([]);
  listOfStatusAll: BehaviorSubject<any> = new BehaviorSubject([]);
  allStatusList = [];
  public userId: any;
  public roleId: any;
  allMenuItems: BehaviorSubject<any> = new BehaviorSubject({
    menuItemsList: [],
  });
  isNextDueSort: BehaviorSubject<Boolean> = new BehaviorSubject(false);
  constructor(
    /**Query */
    public commonQueryService: CommonQueryService,
    public scheduleQueryService: ScheduleQueryService,

  ) {
    // this.getAllStatus();
    this.userId = window.localStorage.getItem('userUID');
    this.roleId = window.localStorage.getItem('roleId');
    this.fetchMenu();
  }

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    this.routeParams = route.params;

    return new Promise(async (resolve, reject) => {
      Promise.all([
        // await this.getAllStatus(),
        this.userId = window.localStorage.getItem('userUID'),
        this.roleId = window.localStorage.getItem('roleId'),
        await this.fetchMenu(),
      ]).then(() => {
        resolve('');
      }, reject);
    });
  }

  fetchMenu() {
    if (environment.ownerRoleId === this.roleId || environment.executiveRoleId === this.roleId) {
      this.getAllMenuItems();
      this.getAllStatusForExecutive();
      this.getAllStatusWithDeleted();
    } else {
      this.getAllMenuItemsbyRoleId(this.roleId, this.userId);
      this.getAllStatusbyRoleId(this.roleId, this.userId);
      this.getAllStatusWithDeleted();
    }
  }
  hoursBasedCost(productCost, discountAmount, paidAmount, createdDate) {
    let dueDate;
    if (productCost == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate))
        .add(72, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (productCost + 20 == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate))
        .add(48, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (productCost + 40 == discountAmount + paidAmount) {
      dueDate = moment(new Date(createdDate))
        .add(24, 'hours')
        .format('MM/DD/YYYY');
    }
    return dueDate;
  }

  calcDueDate(deliveryTime, createdDate) {
    let dueDate;

    if (deliveryTime.value.includes('72 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(72, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (deliveryTime.value.includes('48 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(48, 'hours')
        .format('MM/DD/YYYY');
    }

    else if (deliveryTime.value.includes('24 hours')) {
      dueDate = moment(new Date(createdDate))
        .add(24, 'hours')
        .format('MM/DD/YYYY');
    }
    return dueDate;
  }
  /**Check orders with fetched data */
  // Updated checkDocProcess method for commonOrders.service.ts
  checkDocProcess(orders) {
    return new Promise((resolve, reject) => {
      var finalOrders = [];
      let proFirstName = '';
      let proLastName = '';

      _.each(orders, async (data, key: number) => {
        let orderContentDetails = JSON.parse(data.orderContent);
        let updatedAt = data && data.inspectionReportsSrcByOrderId
          && data.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId
          && data.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId.statusChangeAt ?
          data.inspectionReportsSrcByOrderId.scheduleRequestByScheduleRequestId.statusChangeAt : '';

        /*Convert GMT to EST  start*/
        if (data.latitude && data.longitude) {
          orderContentDetails.date_created = this.convertUtcToEst(orderContentDetails.date_created);
        }
        // dueDate = this.convertUtcToEst(dueDate);
        /*Convert GMT to EST  end*/
        var dueDate;
        var deliveryTime =
          orderContentDetails.line_items && orderContentDetails.line_items.length > 0
            ? _.find(orderContentDetails.line_items[0].meta_data, {
              key: this.checkoutFields.deliveryTime,
            })
            : null;
        let product = orderContentDetails && orderContentDetails.line_items.length > 0 ? orderContentDetails.line_items[0].sku : '';
        if (product == this.spekwoValues.prouct1 || product == this.spekwoValues.prouct4 || product == this.spekwoValues.prouct5) {
          var check =
            orderContentDetails.line_items && orderContentDetails.line_items.length > 0
              ? _.find(orderContentDetails.line_items[0].meta_data, {
                key: this.checkoutFields.deliveryTime,
              })
              : null;
          let paiAmount = orderContentDetails && orderContentDetails.total ? orderContentDetails.total : 0.00;
          let discount = orderContentDetails && orderContentDetails.coupon_lines.length > 0 && orderContentDetails.coupon_lines[0].discount ? orderContentDetails.coupon_lines[0].discount : 0.00;
          let couponData = data && data.couponByCouponId ? data.couponByCouponId : {};
          let productData = data && data.productByProductId ? data.productByProductId : {};

          if (discount === 0 || discount === 0.00) {
            discount = couponData && couponData.couponAmount ? couponData.couponAmount : 0.00;
          }

          if (!product) {
            product = productData && productData.sku ? productData.sku : "";
          }
          let productAmount = productData && productData.productPrice ? productData.productPrice : 0.00;
          if (product == this.spekwoValues.prouct1) {
            dueDate = this.calcDueDate(deliveryTime, orderContentDetails.date_created);
          }
          else if (product == this.spekwoValues.prouct4 || product == this.spekwoValues.prouct5) {
            dueDate = this.calcDueDate(deliveryTime, orderContentDetails.date_created);
          }
        } else if (
          product == this.spekwoValues.prouct2 ||
          product == this.spekwoValues.prouct3
        ) {
          var check = _.find(orderContentDetails.meta_data, {
            key: this.checkoutFields.apptDate,
          });

          dueDate = check ? moment(new Date(check.value)).format('MM/DD/YYYY') : '';

        }
        //todo: nill to - handle in UI and set null
        var buyerProperty = orderContentDetails
          ? _.find(orderContentDetails.meta_data, { key: checkoutFields.buyerProperty })
          : 'nill'; // Buyer property
        var clientPropertyRole = orderContentDetails
          ? _.find(orderContentDetails.meta_data, { key: checkoutFields.propertyRole })
          : 'nill'; // clientPropertyRole Name
        var agentType = orderContentDetails
          ? _.find(orderContentDetails.meta_data, { key: checkoutFields.agentRole })
          : 'nill'; // agentType Name
        var clientName = orderContentDetails
          ? _.find(orderContentDetails.meta_data, { key: checkoutFields.clientName })
          : 'nill'; // Client Name
        var solEmail = orderContentDetails
          ? _.find(orderContentDetails.meta_data, { key: checkoutFields.solEmail })
          : 'nill'; // solution send email id
        var specificItems = orderContentDetails
          ? _.find(orderContentDetails.meta_data, { key: checkoutFields.itemList })
          : 'nill'; // specific itemList
        var invoiceName = orderContentDetails ? _.find(orderContentDetails.meta_data, { key: checkoutFields.customInvoiceClientName }) : ''; // invoice name
        var invoiceEmail = orderContentDetails ? _.find(orderContentDetails.meta_data, { key: checkoutFields.customInvoiceClientEmail }) : ''; // Solution  email
        var agentName = orderContentDetails
          ? _.find(orderContentDetails.meta_data, { key: checkoutFields.agentName })
          : 'nill'; // Agent Name
        var agentEmail = orderContentDetails
          ? _.find(orderContentDetails.meta_data, { key: checkoutFields.agentEmail })
          : 'nill'; // Agent Email

        var homeInspection = orderContentDetails
          ? _.find(orderContentDetails.line_items[0].meta_data, { key: checkoutFields.homeInspection })
          : 'null';

        var ddraReport = orderContentDetails
          ? _.find(orderContentDetails.line_items[0].meta_data, { key: checkoutFields.ddraReport })
          : 'null';

        var wdo = orderContentDetails
          ? _.find(orderContentDetails.line_items[0].meta_data, { key: checkoutFields.wdo })
          : 'null';

        var structuralEng = orderContentDetails
          ? _.find(orderContentDetails.line_items[0].meta_data, { key: checkoutFields.structuralEng })
          : 'null';

        var wellReport = orderContentDetails
          ? _.find(orderContentDetails.line_items[0].meta_data, { key: checkoutFields.well })
          : 'null';

        let statusId = data && data.statusId ? data.statusId : null;

        let orderClaimdData = data && data.claimOrdersByOrderId && data.claimOrdersByOrderId.nodes && data.claimOrdersByOrderId.nodes.length > 0 ? data.claimOrdersByOrderId.nodes : [];

        let formatOrderClaimData = await this.formatClaimOrder(orderClaimdData);

        // role based filter
        let qca = null; let estimator = null; let fo = null; let blueTeam = null;
        if (data && data.inspectionReportsSrcByOrderId && data.inspectionReportsSrcByOrderId.solutionestimateusersByReportid) {

          qca = _.filter(data.inspectionReportsSrcByOrderId.solutionestimateusersByReportid.nodes, event =>
            event.roleid === this.ordersValues.roleId.qca);
          estimator = _.filter(data.inspectionReportsSrcByOrderId.solutionestimateusersByReportid.nodes, event =>
            event.roleid === this.ordersValues.roleId.estimator);
          fo = _.filter(data.inspectionReportsSrcByOrderId.solutionestimateusersByReportid.nodes, event =>
            event.roleid === this.ordersValues.roleId.fo);
          blueTeam = _.filter(data.inspectionReportsSrcByOrderId.solutionestimateusersByReportid.nodes, event =>
            event.roleid === this.ordersValues.roleId.blueTeam);
          qca = qca.length > 0 && qca[0] ? qca[0].userByUserid.firstName + ' ' + qca[0].userByUserid.lastName : null;
          estimator = estimator.length > 0 && estimator[0] ? estimator[0].userByUserid.firstName + ' ' + estimator[0].userByUserid.lastName : null;
          fo = fo.length > 0 && fo[0] ? fo[0].userByUserid.firstName + ' ' + fo[0].userByUserid.lastName : null;
          blueTeam = blueTeam.length > 0 && blueTeam[0] ? blueTeam[0].userByUserid.firstName + ' ' + blueTeam[0].userByUserid.lastName : null;

        }

        //product name
        let product_name = (orderContentDetails && orderContentDetails.line_items.length > 0) &&
          product == this.spekwoValues.prouct1 ? this.spekwoValues.HIQFULL :
          product == this.spekwoValues.prouct2 ? this.spekwoValues.INSPECTIONCALL :
            product == this.spekwoValues.prouct3 ? this.spekwoValues.GCCONSULTING :
              product == this.spekwoValues.prouct5 ? this.spekwoValues.RJCZPSJ :
                product == this.spekwoValues.prouct4 ? this.spekwoValues.CGPYWCK : '';

        // ENHANCED STATUS PROCESSING - FIXED VERSION
        let filterStatus = await this.getStatusNameByStatusId(statusId);
        let filterClaimOrder = await this.claimDataFilter(statusId, formatOrderClaimData);
        let progressUserId = filterClaimOrder.length > 0 && filterClaimOrder[0] && filterClaimOrder[0].userId ? filterClaimOrder[0].userId : null;

        let statusName = "Unknown Status";
        let statusUnique = "unknown_status";
        let statusColor = "#757575";


        if (filterStatus && filterStatus.length > 0 && filterStatus[0]) {
          const status = filterStatus[0];

          if (status.displayStatus && status.displayStatus.trim() !== '') {
            statusName = status.displayStatus.trim();
          } else if (status.statusName && status.statusName.trim() !== '') {
            statusName = status.statusName.trim();
          }

          statusUnique = (status.statusName && status.statusName.trim() !== '') ? status.statusName.trim() : "unknown_status";
          statusColor = status.statusColor || "#757575";

        } else {
          // Fallback 1: Try getAllStatus
          try {
            const allStatuses: any = await this.getAllStatus();
            if (allStatuses && Array.isArray(allStatuses) && allStatuses.length > 0) {
              const directStatus = allStatuses.find((s: any) => s.statusId === statusId);
              if (directStatus) {
                statusName = directStatus.displayStatus || directStatus.statusName || statusName;
                statusUnique = directStatus.statusName || "unknown_status";
                statusColor = directStatus.statusColor || "#757575";
              }
            }
          } catch (error) {
            console.error('getAllStatus failed:', error);
          }

          // Fallback 2: Hardcoded mapping if getAllStatus fails
          if (statusName === "Unknown Status" && statusId) {
            const statusMapping = {
              1: { name: "Onboard", unique: "initiate", color: "#EF6C00" },
              2: { name: "Estimate", unique: "ready_to_estimate", color: "#2196F3" },
              3: { name: "S.E Complete", unique: "se_complete", color: "#2196F3" },
              4: { name: "Work Requested", unique: "work_requested", color: "#673AB7" },
              5: { name: "Work Assigned", unique: "work_assigned", color: "#4CAF50" },
              6: { name: "Job Completed", unique: "completed", color: "#4CAF50" },
              7: { name: "Declined", unique: "declined", color: "#F44336" },
              8: { name: "Work in Progress", unique: "work_in_progress", color: "#FF9800" },
              11: { name: "Accepted", unique: "accepted", color: "#4CAF50" },
              12: { name: "Cancel Work Request", unique: "cancel_work_request", color: "#F44336" },
              18: { name: "First Review", unique: "first_review", color: "#E91E63" },
              19: { name: "Final Review", unique: "final_review", color: "#9C27B0" },
              20: { name: "Second Review", unique: "second_review", color: "#607D8B" }
            };

            const mappedStatus = statusMapping[statusId];
            if (mappedStatus) {
              statusName = mappedStatus.name;
              statusUnique = mappedStatus.unique;
              statusColor = mappedStatus.color;
            } else {
              statusName = 'Status ID ' + statusId;
            }
          }
        }

        if (!statusName || statusName.trim() === '') {
          statusName = 'Status ID ' + (statusId || 'Unknown');
        }
        if (!statusUnique || statusUnique.trim() === '') {
          statusUnique = 'unknown_status';
        }
        if (!statusColor || statusColor.trim() === '') {
          statusColor = '#757575';
        }

        let agentroleName = data.agentrole ? decodeData(data.agentrole) : "";
        let filterAgentRole = orderAgentRoles.filter((agentrole: any) => {
          return agentrole.value.toLowerCase() === agentroleName.toLowerCase();
        });

        dueDate = dueDate ? dueDate : (data && data.duedate ? data.duedate : "");

        //set all order details
        let orderDetails = {
          statusId: statusId ? statusId : 1,
          statusName: statusName,
          statusUnique: statusUnique,
          statusOrder: filterStatus && filterStatus.length > 0 && filterStatus[0].statusName ? statusOrder[filterStatus[0].statusName] : 0,
          statusColor: statusColor,
          progressInfo: filterClaimOrder.length > 0 && filterClaimOrder[0].userFirstName ? " - " + filterClaimOrder[0].userFirstName : "",
          isProgressing: filterClaimOrder.length > 0 ? true : false,
          proFirstName: proFirstName ? proFirstName : '',
          proLastName: proLastName ? proLastName : '',
          agentName: agentName && agentName.value ? agentName.value : '',
          agentEmail: agentEmail && agentEmail.value ? agentEmail.value : '',
          archive: data && data.archive ? data.archive : 0,
          nodeId: data && data.nodeId ? data.nodeId : null,
          longitude: data && data.longitude ? data.longitude : null,
          latitude: data && data.latitude ? data.latitude : null,
          first_name: orderContentDetails ? orderContentDetails.billing.first_name : '',
          last_name: orderContentDetails ? orderContentDetails.billing.last_name : '',
          city: orderContentDetails ? orderContentDetails.billing.city : '',
          state: orderContentDetails ? orderContentDetails.billing.state : '',
          country: orderContentDetails ? orderContentDetails.billing.country : '',
          postcode: orderContentDetails ? orderContentDetails.billing.postcode : '',
          email: orderContentDetails ? orderContentDetails.billing.email : '',
          phone: orderContentDetails ? orderContentDetails.billing.phone : '',
          clientPropertyRole: clientPropertyRole && clientPropertyRole.value ? clientPropertyRole.value : '',
          agentType: agentType && agentType.value ? agentType.value : '',
          clientName: clientName && clientName.value ? clientName.value : '',
          buyerProperty: buyerProperty ? buyerProperty.value : '',
          solEmail: solEmail && solEmail.value ? solEmail.value : '',
          specificItems: specificItems && specificItems.value ? specificItems.value : [],
          dueDate: orderContentDetails ? moment(dueDate).format('MM/DD/YYYY') : '',
          createdVia: orderContentDetails && orderContentDetails.created_via ? orderContentDetails.created_via : '',
          totalAmount: orderContentDetails && orderContentDetails.total ? Number(orderContentDetails.total) : '',
          invoiceEmail: invoiceEmail && invoiceEmail.value ? invoiceEmail.value : '',  //Invoice client email
          invoiceName: invoiceName && invoiceName.value ? invoiceName.value : '',
          qcaName: qca,
          estimatorName: estimator,
          foName: fo,
          blueTeamName: blueTeam,
          date_created: orderContentDetails ? moment(orderContentDetails.date_created).format('MM/DD/YYYY hh:mm a') : null,
          date_created1: orderContentDetails ? moment(new Date(orderContentDetails.date_created)).format('MM/DD/YYYY') : '',
          orderChangesDate: data && data.orderedDate ? moment(new Date(data.orderedDate)).format('MM/DD/YYYY') : '',
          product_name: product_name,
          insReportId: data && data.inspectionReportsSrcByOrderId ? data.inspectionReportsSrcByOrderId.insReportId : '',
          updatedAt: updatedAt ?
            moment1(updatedAt).tz('America/New_York').format('YYYY-MM-DD HH:mm:ss')
            :
            orderContentDetails ? moment(new Date(orderContentDetails.date_created)).format('YYYY-MM-DD HH:mm:ss') : null,
          firmName: data.firmByFirmId && data.firmByFirmId.firmsName ? decodeData(data.firmByFirmId.firmsName) : "",
          marketName: data.marketByMarketId && data.marketByMarketId.marketName ? decodeData(data.marketByMarketId.marketName) : "",
          officeName: data.officeByOfficeId && data.officeByOfficeId.officesName ? decodeData(data.officeByOfficeId.officesName) : "",
          clientNameUI: (data.firstName ? decodeData(data.firstName) : (data.first_name ? decodeData(data.first_name) : "")) + (data.lastName ? (" " + decodeData(data.lastName)) : (data.last_name ? (" " + decodeData(data.last_name)) : "")),
          indrole: data.indrole ? decodeData(data.indrole) : "",
          agentrole: filterAgentRole.length > 0 && filterAgentRole[0].key ? filterAgentRole[0].key : "",
          productId: data.productId ? data.productId : null,
          orderClaimdData: formatOrderClaimData,
          isProgressingUser: this.userId === progressUserId ? true : false,
          stripeLink: data.stripeinvoicesByOrderId && data.stripeinvoicesByOrderId.nodes
            && data.stripeinvoicesByOrderId.nodes.length > 0 &&
            data.stripeinvoicesByOrderId.nodes[0].chargeObject &&
            JSON.parse(data.stripeinvoicesByOrderId.nodes[0].chargeObject).receipt_url
            ?
            JSON.parse(data.stripeinvoicesByOrderId.nodes[0].chargeObject).receipt_url : null,
          homeInspection: homeInspection && homeInspection.id ? homeInspection.value : null,
          ddraReport: ddraReport && ddraReport.id ? ddraReport.value : null,
          wdo: wdo && wdo.id ? wdo.value : null,
          structuralEng: structuralEng && structuralEng.id ? structuralEng.value : null,
          wellReport: wellReport && wellReport.id ? wellReport.value : null,
          firmId: data.firmByFirmId && data.firmByFirmId.firmId ? data.firmByFirmId.firmId : null,
          officeId: data.officeByOfficeId && data.officeByOfficeId.officeId ? data.officeByOfficeId.officeId : null,
          marketId: data.marketByMarketId && data.marketByMarketId.marketId ? data.marketByMarketId.marketId : null,
        }
        data = Object.assign({}, data);
        data = Object.assign({}, data, orderDetails);

        finalOrders.push(data);
        key++;

        if (orders.length == key) {
          this.isNextDueSort.subscribe(async (result) => {
            if (result) finalOrders = await this.seStatusInLast(finalOrders);
            resolve(finalOrders);
          });
        }
      });
    });
  }


  getAllOrders(from, cursor) {

    return new Promise((resolve, reject) => {

      //get orders list via query
      this.commonQueryService.GET_ALL_ORDERS(from, cursor).valueChanges.subscribe((response: any) => {

        if (response && response.data) {
          this.orders = response.data && response.data.allOrders;
          resolve(this.orders);
        } else {
          reject;
        }
      }, reject);
    });

  }

  getAllOrdersNew(query, payload) {
    return new Promise((resolve, reject) => {

      //get orders list via query
      this.commonQueryService.GET_ALL_ORDERS_NEW(query, payload).valueChanges
        .subscribe((response: any) => {
          if (response && response.data) {
            this.orders = response.data && response.data.allOrders;
            resolve(this.orders);
          } else {
            reject;
          }
        }, reject);
    });

  }

getAllOrderIdWithSearchStrSpecificFields(searchString: string, unArchive: boolean): Promise<any> {
  return new Promise((resolve, reject) => {
    // Check if searchString is numeric for ID search
    const isNumeric = /^\d+$/.test(searchString);
    // First, try the specific field search
    const specificFieldsQuery = `
    query searchOrderSpecificFields($searchStr: String!, $unArchive: Boolean!${isNumeric ? ', $orderId: Int!' : ''}) {
      searchOrdersBySpecificFields: allOrders(
        filter: {
          archive: {isNull: $unArchive},
          or: [
            ${isNumeric ? '{id: {equalTo: $orderId}},' : ''}
            {firstName: {includesInsensitive: $searchStr}},
            {clientemail: {includesInsensitive: $searchStr}},
            {address: {includesInsensitive: $searchStr}}
          ]
        }
      ) {
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          address
          firstName
          lastName
          indrole
          agentrole
          statusId
          longitude
          latitude
          couponId
          duedate
          couponByCouponId {
            couponAmount
          }
          productId
          productByProductId {
            productId
            productName
            productPrice
            sku
          }
          stripeinvoicesByOrderId {
            nodes {
              orderId
              invoiceid
              chargeObject
              invoiceObject
            }
          }
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus
              }
              roleByRoleId {
                roleName
              }
              userByUserId {
                firstName
                lastName
              }
            }
          }
          firmByFirmId {
            firmsName
          }
          officeByOfficeId {
            officesName
          }
          marketByMarketId {
            marketName
          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId
                }
              }
            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email
              }
            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName
                }
                userByUserid {
                  userId
                  firstName
                  lastName
                }
                createdat
              }
            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id
              }
            }
          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
        totalCount
      }
    }`;
    // Variables for the specific fields query
    const variables: any = {
      searchStr: searchString.trim(),
      unArchive: unArchive
    };
    if (isNumeric) {
      variables.orderId = parseInt(searchString);
    }
    console.log('Starting elevated search with specific fields:', {
      searchString: searchString.trim(),
      searchFields: ['id', 'firstName', 'clientemail', 'address'],
      unArchive: unArchive
    });
    // Execute the specific fields search first
    this.commonQueryService.GET_ALL_ORDERS_NEW(specificFieldsQuery, variables)
      .valueChanges
      .subscribe(
        (response: any) => {
          if (response && response.data && response.data.searchOrdersBySpecificFields && 
              response.data.searchOrdersBySpecificFields.nodes.length > 0) {
            
            console.log('Elevated specific fields search successful:', {
              searchTerm: searchString,
              totalFound: response.data.searchOrdersBySpecificFields.totalCount,
              ordersReturned: response.data.searchOrdersBySpecificFields.nodes.length
            });
            
            resolve(response.data.searchOrdersBySpecificFields.nodes);
          } else {
            console.log('Elevated specific fields search returned no results, trying fallback...');
            
            // If no results from specific fields, try the fallback search
            this.performElevatedFallbackSearch(searchString, unArchive)
              .then((fallbackResults) => {
                console.log('Elevated fallback search completed:', {
                  searchTerm: searchString,
                  fallbackResultsCount: fallbackResults.length
                });
                resolve(fallbackResults);
              })
              .catch((fallbackError) => {
                console.error('Elevated fallback search also failed:', fallbackError);
                resolve([]);
              });
          }
        },
        error => {
          console.error("Elevated specific fields search error, trying fallback:", error);
          
          this.performElevatedFallbackSearch(searchString, unArchive)
            .then((fallbackResults) => {
              resolve(fallbackResults);
            })
            .catch((fallbackError) => {
              console.error('Both elevated searches failed:', fallbackError);
              reject(fallbackError);
            });
        }
      );
  });
}

getAllOrderIdWithSearchStrSpecificFieldss(searchString: string, unArchive: boolean): Promise<any> {
  return new Promise((resolve, reject) => {
    // Build query for firstName and clientemail search only
    const query = `
    query searchOrderSpecificFields($searchStr: String!, $unArchive: Boolean!) {
      searchOrdersBySpecificFields: allOrders(
        filter: {
          archive: {isNull: $unArchive},
          or: [
            {firstName: {includesInsensitive: $searchStr}},
            {clientemail: {includesInsensitive: $searchStr}}
          ]
        }
      ) {
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          firstName
          lastName
          indrole
          agentrole
          statusId
          longitude
          latitude
          couponId
          duedate
          couponByCouponId {
            couponAmount
          }
          productId
          productByProductId {
            productId
            productName
            productPrice
            sku
          }
          stripeinvoicesByOrderId {
            nodes {
              orderId
              invoiceid
              chargeObject
              invoiceObject
            }
          }
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus
              }
              roleByRoleId {
                roleName
              }
              userByUserId {
                firstName
                lastName
              }
            }
          }
          firmByFirmId {
            firmsName
          }
          officeByOfficeId {
            officesName
          }
          marketByMarketId {
            marketName
          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId
                }
              }
            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email
              }
            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName
                }
                userByUserid {
                  userId
                  firstName
                  lastName
                }
                createdat
              }
            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id
              }
            }
          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
        totalCount
      }
    }`;

    // Variables for firstName and clientemail search only
    const variables = {
      searchStr: searchString.trim(),
      unArchive: unArchive
    };

    console.log('Searching orders with:', {
      searchString: searchString.trim(),
      unArchive: unArchive,
      searchFields: ['firstName', 'clientemail']
    });

    this.commonQueryService.GET_ALL_ORDERS_NEW(query, variables)
      .valueChanges
      .subscribe(
        (response: any) => {
          if (response && response.data && response.data.searchOrdersBySpecificFields) {
            console.log('Search query completed:', {
              searchTerm: searchString,
              totalFound: response.data.searchOrdersBySpecificFields.totalCount,
              ordersReturned: response.data.searchOrdersBySpecificFields.nodes.length
            });
            resolve(response.data.searchOrdersBySpecificFields.nodes);
          } else {
            console.log('No search results found');
            resolve([]);
          }
        },
        error => {
          console.error("firstName/clientemail search query error:", error);
          reject(error);
        }
      );
  });
}

  // Search method for specific fields with role restrictions
getAllOrderIdWithSearchStrByRolesSpecificFields(searchString: string, roleStatusList: number[], unArchive: boolean): Promise<any> {
  return new Promise((resolve, reject) => {
    // Check if searchString is numeric for ID search
    const isNumeric = /^\d+$/.test(searchString);
    // First, try the specific field search with role restrictions
    const specificFieldsQuery = `
    query searchOrderSpecificFieldsByRoles($searchStr: String!, $statusIds: [Int!], $unArchive: Boolean!${isNumeric ? ', $orderId: Int!' : ''}) {
      searchOrdersBySpecificFields: allOrders(
        filter: {
          statusId: {in: $statusIds},
          archive: {isNull: $unArchive},
          or: [
            ${isNumeric ? '{id: {equalTo: $orderId}},' : ''}
            {firstName: {includesInsensitive: $searchStr}},
            {clientemail: {includesInsensitive: $searchStr}},
            {address: {includesInsensitive: $searchStr}}
          ]
        }
      ) {
        pageInfo {
          hasNextPage
        }
        nodes {
          id
          nodeId
          clientphone
          clientemail
          archive
          address
          firstName
          lastName
          indrole
          agentrole
          statusId
          longitude
          latitude
          couponId
          duedate
          couponByCouponId {
            couponAmount
          }
          productId
          productByProductId {
            productId
            productName
            productPrice
            sku
          }
          stripeinvoicesByOrderId {
            nodes {
              orderId
              invoiceid
              chargeObject
              invoiceObject
            }
          }
          claimOrdersByOrderId(filter: {isDeletedYn: {equalTo: false}}) {
            nodes {
              claimOrderId
              orderId
              statusId
              userId
              roleId
              statusByStatusId {
                statusName
                displayStatus
              }
              roleByRoleId {
                roleName
              }
              userByUserId {
                firstName
                lastName
              }
            }
          }
          firmByFirmId {
            firmsName
          }
          officeByOfficeId {
            officesName
          }
          marketByMarketId {
            marketName
          }
          orderContent
          orderedDate
          createdAt
          inspectionReportsSrcByOrderId {
            id
            orderId
            insReportId
            reportReviewDetailsByInsReportId(first: 1) {
              edges {
                node {
                  orderId
                  reviewId
                }
              }
            }
            scheduleRequestByScheduleRequestId {
              id
              createdAt
              statusId
              statusChangeAt
              scheduleRequestDate
              nodeId
              userByAcceptedBy {
                firstName
                lastName
                email
              }
            }
            solutionestimateusersByReportid(orderBy: CREATEDAT_DESC) {
              nodes {
                roleid
                roleByRoleid {
                  roleId
                  roleName
                }
                userByUserid {
                  userId
                  firstName
                  lastName
                }
                createdat
              }
            }
            reportSolutionMastersByInsReportId(first: 1) {
              nodes {
                createdAt
                id
              }
            }
          }
          orderStatusesByOrderId(orderBy: ID_DESC, first: 1) {
            nodes {
              orderId
              statusId
              statusByStatusId {
                statusId
                statusName
              }
            }
          }
        }
        totalCount
      }
    }`;
    // Variables for the role-based specific fields query
    const variables: any = {
      searchStr: searchString.trim(),
      statusIds: roleStatusList,
      unArchive: unArchive
    };
    if (isNumeric) {
      variables.orderId = parseInt(searchString);
    }
    console.log('Starting role-based search with specific fields:', {
      searchString: searchString.trim(),
      searchFields: ['id', 'firstName', 'clientemail', 'address'],
      roleStatusList: roleStatusList,
      unArchive: unArchive
    });
    // Execute the specific fields search first
    this.commonQueryService.GET_ALL_ORDERS_NEW(specificFieldsQuery, variables)
      .valueChanges
      .subscribe(
        (response: any) => {
          if (response && response.data && response.data.searchOrdersBySpecificFields && 
              response.data.searchOrdersBySpecificFields.nodes.length > 0) {
            
            console.log('Role-based specific fields search successful:', {
              searchTerm: searchString,
              totalFound: response.data.searchOrdersBySpecificFields.totalCount,
              ordersReturned: response.data.searchOrdersBySpecificFields.nodes.length
            });
            
            resolve(response.data.searchOrdersBySpecificFields.nodes);
          } else {
            console.log('Role-based specific fields search returned no results, trying fallback...');
            
            // If no results from specific fields, try the fallback search
            this.performRoleBasedFallbackSearch(searchString, roleStatusList, unArchive)
              .then((fallbackResults) => {
                console.log('Role-based fallback search completed:', {
                  searchTerm: searchString,
                  fallbackResultsCount: fallbackResults.length
                });
                resolve(fallbackResults);
              })
              .catch((fallbackError) => {
                console.error('Role-based fallback search also failed:', fallbackError);
                resolve([]);
              });
          }
        },
        error => {
          console.error("Role-based specific fields search error, trying fallback:", error);
          
          this.performRoleBasedFallbackSearch(searchString, roleStatusList, unArchive)
            .then((fallbackResults) => {
              resolve(fallbackResults);
            })
            .catch((fallbackError) => {
              console.error('Both role-based searches failed:', fallbackError);
              reject(fallbackError);
            });
        }
      );
  });
}
// Helper method for elevated permissions fallback search
private performElevatedFallbackSearch(searchString: string, unArchive: boolean): Promise<any[]> {
  return new Promise((resolve, reject) => {
    // Use the existing working search method as fallback
    this.commonQueryService.GET_ALL_ORDER_FOR_SEARCH(searchString, unArchive)
      .valueChanges
      .subscribe(
        (response: any) => {
          if (response && response.data && response.data.searchOrdersNew) {
            const searchResults = response.data.searchOrdersNew.nodes || [];
            
            // Filter the results to prioritize matches that include insReportId
            const filteredResults = this.filterResultsForInsReportId(searchResults, searchString);
            
            resolve(filteredResults);
          } else {
            resolve([]);
          }
        },
        error => {
          console.error("Elevated fallback search error:", error);
          reject(error);
        }
      );
  });
}
// Helper method for role-based fallback search
private performRoleBasedFallbackSearch(searchString: string, roleStatusList: number[], unArchive: boolean): Promise<any[]> {
  return new Promise((resolve, reject) => {
    // Use the existing working role-based search method as fallback
    this.commonQueryService.GET_ALL_ORDER_FOR_SEARCH_BY_ROLES(searchString, roleStatusList, unArchive)
      .valueChanges
      .subscribe(
        (response: any) => {
          if (response && response.data && response.data.searchOrdersNew) {
            const searchResults = response.data.searchOrdersNew.nodes || [];
            
            // Filter the results to prioritize matches that include insReportId
            const filteredResults = this.filterResultsForInsReportId(searchResults, searchString);
            
            resolve(filteredResults);
          } else {
            resolve([]);
          }
        },
        error => {
          console.error("Role-based fallback search error:", error);
          reject(error);
        }
      );
  });
}

private filterResultsForInsReportId(results: any[], searchString: string): any[] {
  const searchLower = searchString.toLowerCase();
  const insReportMatches = [];
  const otherMatches = [];
  results.forEach(order => {
    // Check if insReportId matches
    if (order.inspectionReportsSrcByOrderId && 
        order.inspectionReportsSrcByOrderId.insReportId && 
        order.inspectionReportsSrcByOrderId.insReportId.toLowerCase().includes(searchLower)) {
      
      console.log('Found insReportId match:', {
        orderId: order.id,
        insReportId: order.inspectionReportsSrcByOrderId.insReportId,
        searchTerm: searchString
      });
      
      insReportMatches.push(order);
    } else {
      // Check other fields for matches
      const hasOtherMatch = (
        (order.id && order.id.toString().includes(searchString)) ||
        (order.firstName && order.firstName.toLowerCase().includes(searchLower)) ||
        (order.clientemail && order.clientemail.toLowerCase().includes(searchLower)) ||
        (order.address && order.address.toLowerCase().includes(searchLower))
      );
      
      if (hasOtherMatch) {
        otherMatches.push(order);
      }
    }
  });
  // Return insReportId matches first, then other matches
  const combinedResults = [...insReportMatches, ...otherMatches];
  
  console.log('Filtered fallback results:', {
    insReportIdMatches: insReportMatches.length,
    otherMatches: otherMatches.length,
    totalReturned: combinedResults.length
  });
  return combinedResults;
}


  //get all status
  getAllStatus() {
    let allStatusList = [];
    return new Promise((resolve, reject) => {
      this.scheduleQueryService
        .GET_STATUS_ALL().valueChanges
        .subscribe((response: any) => {
          resolve(response);
          allStatusList = response && response.data && response.data.allStatuses && response.data.allStatuses.nodes && response.data.allStatuses.nodes.length > 0 ? response.data.allStatuses.nodes : [];
          this.listOfStatus.next(allStatusList);
          this.allStatusList = allStatusList;
        }, reject)
    });
  }

  getAllStatusWithDeleted() {
    let allStatusList = [];
    return new Promise((resolve, reject) => {
      this.scheduleQueryService
        .GET_STATUS_ALL_WITH_DELETE().valueChanges
        .subscribe((response: any) => {
          resolve(response);
          allStatusList = response && response.data && response.data.allStatuses && response.data.allStatuses.nodes && response.data.allStatuses.nodes.length > 0 ? response.data.allStatuses.nodes : [];
          this.listOfStatusAll.next(allStatusList);
          this.allStatusList = allStatusList;
        }, reject)
    });
  }

  getAllStatusbyRoleId(roleId, userId) {
    return new Promise(async (resolve, reject) => {
      await this.scheduleQueryService.GET_STATUS_ALL_BY_ID_CALL(roleId, userId).valueChanges.subscribe(async (statusRes: any) => {
        let statusData = statusRes && statusRes.data && statusRes.data.allStatuses && statusRes.data.allStatuses.nodes && statusRes.data.allStatuses.nodes.length > 0 ? statusRes.data.allStatuses.nodes : [];
        await this.formatAllStatus(statusData);
        resolve(statusRes);
      }, reject)
    })
  }

  getAllStatusForExecutive() {
    return new Promise(async (resolve, reject) => {
      await this.scheduleQueryService.GET_STATUS_ALL().valueChanges.subscribe(async (statusRes: any) => {
        let statusData = statusRes && statusRes.data && statusRes.data.allStatuses && statusRes.data.allStatuses.nodes && statusRes.data.allStatuses.nodes.length > 0 ? statusRes.data.allStatuses.nodes : [];
        await this.formatAllStatus(statusData);
        resolve(statusRes);
      }, reject)
    })
  }

  formatAllStatus(statusData) {

    let finalStatus = [];
    if (environment.ownerRoleId !== this.roleId && environment.executiveRoleId !== this.roleId) {
      for (let i = 0; i < statusData.length; i++) {
        if (statusData[i] && statusData[i].userStatusPermissionsByStatusId && statusData[i].userStatusPermissionsByStatusId.nodes && statusData[i].userStatusPermissionsByStatusId.nodes.length > 0) {
          let temp = {
            statusId: statusData[i].statusId ? statusData[i].statusId : null,
            statusName: statusData[i].statusName ? statusData[i].statusName : null,
            displayStatus: statusData[i].displayStatus ? statusData[i].displayStatus : null,
            statusColor: statusData[i].statusColor ? statusData[i].statusColor : null,
            availableStatus: statusData[i].availableStatus ? statusData[i].availableStatus : null,
          };
          finalStatus.push(temp);
        }
      }
    } else {
      for (let i = 0; i < statusData.length; i++) {
        let temp = {
          statusId: statusData[i].statusId ? statusData[i].statusId : null,
          statusName: statusData[i].statusName ? statusData[i].statusName : null,
          displayStatus: statusData[i].displayStatus ? statusData[i].displayStatus : null,
          statusColor: statusData[i].statusColor ? statusData[i].statusColor : null,
          availableStatus: statusData[i].availableStatus ? statusData[i].availableStatus : null,
        };
        finalStatus.push(temp);
      }
    }
    this.listOfStatus.next(finalStatus);
    this.allStatusList = finalStatus;
  }

  getStatusNameByStatusId(statusId) {
    return this.allStatusList.filter((status) => {
      return status.statusId === statusId;
    })
  }

  claimDataFilter(statusId, orderClaimdData) {
    return orderClaimdData.filter((claim) => {
      return claim.statusId === statusId;
    })
  }

  statusRolePermissionByRoleId(roleId) {
    return new Promise((resolve, reject) => {
      this.commonQueryService
        .GET_STATUS_ID_BY_ROLE_ID(roleId).valueChanges
        .subscribe((response: any) => {
          let roleStatusData = response && response.data && response.data.allRoleStatusPermissions && response.data.allRoleStatusPermissions.nodes && response.data.allRoleStatusPermissions.nodes.length > 0 ? response.data.allRoleStatusPermissions.nodes : [];
          resolve(roleStatusData);
        }, reject)
    });
  }

  statusRolePermissionByUserId(userId) {
    return new Promise((resolve, reject) => {
      this.commonQueryService
        .GET_STATUS_ID_BY_USER_ID(userId).valueChanges
        .subscribe((response: any) => {
          let userStatusData = response && response.data && response.data.allUserStatusPermissions && response.data.allUserStatusPermissions.nodes && response.data.allUserStatusPermissions.nodes.length > 0 ? response.data.allUserStatusPermissions.nodes : [];
          resolve(userStatusData);
        }, reject)
    });
  }


  getOrderByOrderId(orderId) {
    return new Promise((resolve, reject) => {
      this.commonQueryService.FETCH_ORDER_BY_ID(orderId).valueChanges.subscribe((response: any) => {
        resolve(response);
      }, reject)
    });

  }
  getOrderByOrderIdFun(orderId, userId, roleId) {
    return new Promise((resolve, reject) => {
      this.commonQueryService.FETCH_ORDER_BY_ID_FUN(orderId, userId, roleId).valueChanges.subscribe((response: any) => {
        resolve(response);
      }, reject)
    });

  }

  getAllOrdersCRMBatch(batchSize: number = 50, cursor: string = '') {
    return this.getAllOrders(batchSize, cursor);
  }

  /**
   * Get all orders for CRM using existing method
   */
  getAllOrdersCRM() {
    return this.commonQueryService.apollo.watchQuery({
      query: this.commonQueryService.GET_ALL_ORDERS_CRM,
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    });
  }

  /**
   * Get orders with pagination for CRM using existing method
   */
  getAllOrdersWithPagination(first: number = 50, after: string = null) {
    return this.commonQueryService.apollo.watchQuery({
      query: this.commonQueryService.GET_ALL_ORDERS_CRM_WITH_PG,
      variables: {
        first: first,
        after: after
      },
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    });
  }

  /**
   * Get CRM orders with limit/offset pagination using existing method
   */
  getAllOrdersCRMWithOffset(limit: number = 50, offset: number = 0) {
    return this.commonQueryService.apollo.watchQuery({
      query: this.commonQueryService.GET_ALL_ORDER_DETAILS,
      variables: {
        limit: limit,
        offset: offset
      },
      fetchPolicy: 'network-only',
      errorPolicy: 'all'
    });
  }

  /**
   * Process raw orders into customer data
   */
  processOrdersToCustomers(orders: any[]): any[] {
    const customersMap = new Map();

    orders.forEach(order => {
      const customer = this.parseCustomerFromOrder(order);
      if (customer) {
        const email = customer.email.toLowerCase();
        const existingCustomer = customersMap.get(email);

        // Keep the most recent order for each unique email
        if (!existingCustomer || new Date(customer.createdAt) > new Date(existingCustomer.createdAt)) {
          customersMap.set(email, customer);
        }
      }
    });

    return Array.from(customersMap.values());
  }

  /**
   * Parse individual order to extract customer information
   */
  private parseCustomerFromOrder(order: any): any | null {
    if (!order.orderContent) return null;

    try {
      const orderContentObj = JSON.parse(order.orderContent);
      const billing = orderContentObj.billing;

      if (!billing || !billing.email) return null;

      return {
        orderId: order.id,
        customerName: this.getCustomerName(billing),
        email: billing.email,
        phone: billing.phone || '-',
        address: this.getCustomerAddress(billing),
        createdAt: order.createdAt,
        orderContent: orderContentObj,
        originalOrder: order
      };
    } catch (e) {
      console.error('Error parsing orderContent for order:', order.id, e);
      return null;
    }
  }

  /**
   * Helper method to get customer name from billing info
   */
  private getCustomerName(billing: any): string {
    if (billing.first_name && billing.last_name) {
      return `${billing.first_name} ${billing.last_name}`;
    } else if (billing.first_name) {
      return billing.first_name;
    } else if (billing.last_name) {
      return billing.last_name;
    }
    return '-';
  }

  /**
   * Helper method to get customer address from billing info
   */
  private getCustomerAddress(billing: any): string {
    const addressParts = [];

    if (billing.address_1) addressParts.push(billing.address_1);
    if (billing.address_2) addressParts.push(billing.address_2);
    if (billing.city) addressParts.push(billing.city);
    if (billing.state) addressParts.push(billing.state);
    if (billing.postcode) addressParts.push(billing.postcode);
    if (billing.country) addressParts.push(billing.country);

    return addressParts.length > 0 ? addressParts.join(', ') : '-';
  }


  getOrderByOrderIdNew(orderId) {
    return new Promise((resolve, reject) => {
      this.commonQueryService.FETCH_ORDER_BY_ID_NEW(orderId).valueChanges.subscribe((response: any) => {
        resolve(response);
      }, reject)
    });

  }

  getFilterOrders(query, payload) {
    return new Promise((resolve, reject) => {

      //get orders list via query
      this.commonQueryService.GET_FILTER_ORDERS(query, payload).valueChanges
        .subscribe((response: any) => {
          if (response && response.data) {
            this.orders = response.data && response.data.allOrders;
            resolve(this.orders);
          } else {
            reject;
          }
        }, reject);
    });
  }

  getClaimOrderByStatus(payload) {
    return new Promise((resolve, reject) => {
      this.commonQueryService
        .GET_CLAIM_ORDERS_BY_STATUS(payload)
        .valueChanges.subscribe((response: any) => {
          let claimOrders = response && response.data && response.data.allClaimOrders && response.data.allClaimOrders.nodes && response.data.allClaimOrders.nodes.length > 0 ? response.data.allClaimOrders.nodes : [];
          resolve(claimOrders);
        }, reject)
    });
  }

  createClaimOrder(payload) {
    return new Promise((resolve, reject) => {
      this.commonQueryService.CREATE_CLAIM_ORDERS_F(payload).subscribe((createRes) => {
        resolve(createRes);
      }, reject);
    })
  }

  deleteClaimOrder(id) {
    return new Promise((resolve, reject) => {
      this.commonQueryService.DELETE_CLAIMED_ORDER(id).subscribe((deleteRes) => {
        resolve(deleteRes);
      }, reject);
    })
  }

  async formatClaimOrder(orderClaimdData) {
    let formatClaimOrder = [];
    for (let i = 0; i < orderClaimdData.length; i++) {
      let formatData = {
        roleName: orderClaimdData[i] && orderClaimdData[i].roleByRoleId && orderClaimdData[i].roleByRoleId.roleName ? orderClaimdData[i].roleByRoleId.roleName : null,
        userFirstName: orderClaimdData[i] && orderClaimdData[i].userByUserId && orderClaimdData[i].userByUserId.firstName ? orderClaimdData[i].userByUserId.firstName : null,
        userLastName: orderClaimdData[i] && orderClaimdData[i].userByUserId && orderClaimdData[i].userByUserId.lastName ? orderClaimdData[i].userByUserId.lastName : null,
        statusId: orderClaimdData[i] && orderClaimdData[i].statusId ? orderClaimdData[i].statusId : null,
        userId: orderClaimdData[i] && orderClaimdData[i].userId ? orderClaimdData[i].userId : null,
        claimOrderId: orderClaimdData[i] && orderClaimdData[i].claimOrderId ? orderClaimdData[i].claimOrderId : null,
      };
      formatClaimOrder.push(formatData);
    }
    return formatClaimOrder;
  }

  getAllMenuItemsbyRoleId(roleId, userId) {
    return new Promise(async (resolve, reject) => {
      await this.commonQueryService.GET_MENU_ITEMS_BY_ID_CALL(roleId, userId).valueChanges.subscribe(async (menuItemRes: any) => {
        let menuItemsData = menuItemRes && menuItemRes.data && menuItemRes.data.allMenuItems && menuItemRes.data.allMenuItems.nodes && menuItemRes.data.allMenuItems.nodes.length > 0 ? menuItemRes.data.allMenuItems.nodes : [];
        await this.formatMenuItems(menuItemsData);
        resolve(menuItemRes);
      }, reject)
    })
  }

  getAllMenuItems() {
    return new Promise(async (resolve, reject) => {
      await this.commonQueryService.GET_MENU_ITEMS_CALL().valueChanges.subscribe(async (menuItemRes: any) => {
        let menuItemsData = menuItemRes && menuItemRes.data && menuItemRes.data.allMenuItems && menuItemRes.data.allMenuItems.nodes && menuItemRes.data.allMenuItems.nodes.length > 0 ? menuItemRes.data.allMenuItems.nodes : [];
        await this.formatMenuItems(menuItemsData);
        resolve(menuItemRes);
      }, reject)
    })
  }

  formatMenuItems(menuItemsData) {
    let finalMenu = [];

    // Check if user has elevated permissions (includes Senior Quoter, Junior Quoter, On-boarder)
    const hasElevatedPermissions = environment.ownerRoleId === this.roleId ||
      environment.executiveRoleId === this.roleId ||
      environment.seniorQuoterRoleId === this.roleId ||
      environment.juniorQuoterRoleId === this.roleId ||
      environment.onBoarderRoleId === this.roleId;

    if (!hasElevatedPermissions) {
      // Restricted access - only show menu items with specific permissions
      for (let i = 0; i < menuItemsData.length; i++) {
        if (menuItemsData[i] && menuItemsData[i].userMenuPermissionsByMenuItemId && menuItemsData[i].userMenuPermissionsByMenuItemId.nodes && menuItemsData[i].userMenuPermissionsByMenuItemId.nodes.length > 0) {
          let temp = {
            menuItemId: menuItemsData[i].menuItemId ? menuItemsData[i].menuItemId : null,
            menuItems: menuItemsData[i].menuItems ? menuItemsData[i].menuItems : null,
            parentMenuItem: menuItemsData[i].parentMenuItem ? menuItemsData[i].parentMenuItem : null,
            title: menuItemsData[i].title ? menuItemsData[i].title : null,
            url: menuItemsData[i].url ? menuItemsData[i].url : null,
          };
          finalMenu.push(temp);
        }
      }
    } else {
      // Full access - show all menu items (Owner, Executive, Senior Quoter, Junior Quoter, On-boarder)
      for (let i = 0; i < menuItemsData.length; i++) {
        let temp = {
          menuItemId: menuItemsData[i].menuItemId ? menuItemsData[i].menuItemId : null,
          menuItems: menuItemsData[i].menuItems ? menuItemsData[i].menuItems : null,
          parentMenuItem: menuItemsData[i].parentMenuItem ? menuItemsData[i].parentMenuItem : null,
          title: menuItemsData[i].title ? menuItemsData[i].title : null,
          url: menuItemsData[i].url ? menuItemsData[i].url : null,
        };
        finalMenu.push(temp);
      }
    }
    this.allMenuItems.next({ menuItemsList: finalMenu });
  }

  getAllOrderIdWithSearchStr(searchStr, unArchive) {
    return new Promise(async (resolve, reject) => {
      await this.commonQueryService.GET_ALL_ORDER_FOR_SEARCH(searchStr, unArchive).valueChanges.subscribe(async (searchOrdersRes: any) => {
        let searchOrdersNew = searchOrdersRes && searchOrdersRes.data && searchOrdersRes.data.searchOrdersNew && searchOrdersRes.data.searchOrdersNew.nodes && searchOrdersRes.data.searchOrdersNew.nodes.length > 0 ? searchOrdersRes.data.searchOrdersNew.nodes : [];
        resolve(searchOrdersNew);
      }, reject)
    })
  }

  getAllOrderIdWithSearchStrByRoles(searchStr, statusIds, unArchive) {
    return new Promise(async (resolve, reject) => {
      await this.commonQueryService.GET_ALL_ORDER_FOR_SEARCH_BY_ROLES(searchStr, statusIds, unArchive).valueChanges.subscribe(async (searchOrdersRes: any) => {
        let searchOrdersNew = searchOrdersRes && searchOrdersRes.data && searchOrdersRes.data.searchOrdersNew && searchOrdersRes.data.searchOrdersNew.nodes && searchOrdersRes.data.searchOrdersNew.nodes.length > 0 ? searchOrdersRes.data.searchOrdersNew.nodes : [];
        resolve(searchOrdersNew);
      }, reject)
    })
  }

  getAllOrdersWithSearchStr(ordersId) {
    return new Promise(async (resolve, reject) => {
      await this.commonQueryService.GET_ALL_ORDERS_FOR_SEARCH(ordersId).valueChanges.subscribe(async (allOrdersRes: any) => {
        let allOrders = allOrdersRes && allOrdersRes.data && allOrdersRes.data.allOrders && allOrdersRes.data.allOrders.nodes && allOrdersRes.data.allOrders.nodes.length > 0 ? allOrdersRes.data.allOrders.nodes : [];
        resolve(allOrders);
      }, reject)
    })
  }

  getOrderIdWithSearchStr(searchStr) {
    return new Promise(async (resolve, reject) => {
      await this.commonQueryService.GET_ORDER_FOR_SEARCH(searchStr).valueChanges.subscribe(async (searchOrdersRes: any) => {
        let searchOrdersNew = searchOrdersRes && searchOrdersRes.data && searchOrdersRes.data.searchUsers && searchOrdersRes.data.searchUsers.nodes && searchOrdersRes.data.searchUsers.nodes.length > 0
          ? searchOrdersRes.data.searchUsers.nodes : [];
        resolve(searchOrdersNew);
      }, reject)
    })
  }

  // Custom comparison function
  compareDueDates(taskA, taskB) {
    const dateA: any = new Date(taskA.dueDate);
    const dateB: any = new Date(taskB.dueDate);
    return dateB - dateA;
  }

  convertUtcToEst(timeStamp) {
    if (timeStamp) {
      const gmtTimestamp = timeStamp;

      const gmtDate = new Date(gmtTimestamp);

      const estFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short',
      });

      // Format the GMT date to EST
      let estDateTime = estFormatter.format(gmtDate);
      estDateTime = estDateTime.replace(/\s\w+$/, '');
      return estDateTime;
    }

    return "";
  }

  seStatusInLast(finalOrders) {
    let objectsWithStatus6 = _.filter(finalOrders, function (obj) { return obj.statusOrder === 6; });
    let objectsWithoutStatus6 = _.filter(finalOrders, function (obj) { return obj.statusOrder !== 6; });
    finalOrders = objectsWithoutStatus6.concat(objectsWithStatus6);
    return finalOrders;
  }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/commonOrders.service.ts